import React from "react";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { GenericListProps } from "../../types/GenericListType";
import { ProcessSteps, ProcessStepsProps } from "../../components/ProcessSteps";
import { LinkButton, LinkButtonProps } from "../../components/LinkButton";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { List } from "../../components/List";
import { Responsibilities, ResponsibilitiesProps } from "../../components/Responsibilities";

export interface LiveningElectricityConnectionPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  responsibilities?: ResponsibilitiesProps[];
  processes?: ProcessStepsProps[];
  lists?: GenericListProps[];
  applyButton?: LinkButtonProps;
  faqs?: FaqAccordionGroupProps;
}

export const LiveningElectricityConnectionPage: React.FC<LiveningElectricityConnectionPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  responsibilities,
  processes,
  lists,
  applyButton,
  faqs,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
      {responsibilities && responsibilities[0] && <Responsibilities {...responsibilities[0]} />}
      {processes && processes[0] && <ProcessSteps {...processes[0]} />}
      {lists && lists[0] && <List {...lists[0]} />}
      {applyButton && <LinkButton {...applyButton}>{applyButton.children}</LinkButton>}
    </ServiceCataloguePageWrapper>
  );
};
